<div class="modal-body">
  <button type="button" class="close" (click)="activeModal.dismiss()" data-dismiss="modal"><i
      class="icon-close"></i></button>
  <div class="unquestionBox text-center">
    <h3 class="heading24 mg-b10">Unanswered Questions</h3>
    <p class="textPara mg-b30">Some questions are unanswered. Are you ok to continue?</p>
    <button (click)="goBack()" class="btn btn-outline-primary min-width195" data-bs-toggle="modal"
      data-dismiss="modal"><span>Go
        back</span></button>
    <button (click)="submit()" class="btn btn-primary min-width195"><span>Submit</span></button>
  </div>

</div>